<template>
  <div id="wrapper-mobile-size">
    <div class="wrap">
      <div v-if="resultOfVotes.fetching === 'rejected'">
        <div class="card mt-2 text-center">
          <div class="card-body">
            <p> {{ resultOfVotes.data.message }} </p>
          </div>
        </div>
      </div>
      <div v-else-if="resultOfVotes.fetching === 'resolved'" id="wrapper-content" class="d-flex flex-column">
        <div class="wrap-header">
          <img :src="require('@/assets/images/v2/iluni-ui.png')" alt="Logo" />
          <img :src="require('@/assets/images/v2/ui-connect.png')" alt="Logo" />
          <img :src="require('@/assets/images/v2/pemila.png')" alt="Logo" />
        </div>
        <div class="title">
          <h1>Rekapitulasi e-Vote PEMILA ILUNI UI 2025</h1>
          <span>Last Update: {{ generateAt }}</span>
        </div>
        <div class="wrap-count-vote">
          <h2>Total Vote Masuk</h2>
          <h3>{{ totalVote }}</h3>
        </div>
        <div class="wrap-count-vote-chart">
          <h2 class="mb-2">Total Vote per Kandidat</h2>
          <div class="d-flex justify-content-center align-items-center flex-column overflow-scroll">
            <template v-if="chartData.labels.length > 0">
              <MyBarChart :chart-data="chartData" :chart-options="chartOptions" :width="'1200px'" />
            </template>
          </div>
        </div>
        <div class="wrap-count-vote-chart">
          <h2>Total Vote per Fakultas</h2>
          <div class="d-flex justify-content-between align-items-center flex-row mt-2 mb-1"
            style="padding: 0px 100px 2px 100px; border-bottom: 1px solid #000; font-weight: 800; color: #000;">
            <span>Fakultas</span>
            <span>Total Vote</span>
          </div>

          <div v-for="item in resultOfVotes.data.faculties.faculties.faculties" class="accordion" role="tablist">
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 10px 100px;">
              <span>{{ item.nama_fakultas }}</span>
              <span style="font-weight: 700; color: #000">{{ item.vote_count }}</span>
            </div>
            <!-- <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block @click="toggleAccordion(item.faculty_id)">
                  <div class="d-flex justify-content-between align-items-center flex-row p-relative"
                    style="padding: 0px 80px 2px 79px; font-weight: 800; color: #000;">
                    <span class="icon-right" :class="openAccordions[item.faculty_id] ? 'open' : ''">
                      <chevron-right-icon />
                    </span>
                    <span>{{ item.nama_fakultas }}</span>
                    <span>{{ item.total_votes }}</span>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse accordion="'my-accordion'" class="px-2" role="tabpanel"
                :visible="!!openAccordions[item.faculty_id]">
                <b-card-body style="background: #EBEBEB">
                  <div class="wrap-card-content" v-for="(candidate, index) in item.candidates" :key="index">
                    <span>{{ candidate.no_urut }}</span>
                    <div class="d-flex justify-content-between align-items-center flex-row">
                      <span>{{ candidate.candidate_name }}</span>
                      <span>{{ candidate.vote_count }}</span>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card> -->
          </div>
        </div>
      </div>
    </div>
    <button class="btn-logout" @click="logout">
      Logout
    </button>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCollapse, BButton, BCardText } from 'bootstrap-vue'
import { ChevronRightIcon } from 'vue-feather-icons'
import MyBarChart from './MyBarChart.vue'
import api from '@/api'
import dayjs from 'dayjs'
import 'dayjs/locale/id'

dayjs.locale('id')

export default {
  name: 'MyRecapulation',
  components: {
    MyBarChart, BCard, BCardHeader, BCardBody, BCollapse, BButton, BCardText,
    ChevronRightIcon
  },
  data() {
    return {
      openAccordions: {},
      resultOfVotes: {
        fetching: 'idle',
        data: {
          candidates: null,
          faculties: null,
          statistics: null,
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Nilai',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: { enabled: false },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            font: { weight: 'bold', size: 16 },
            formatter: (value) => Math.round(value),
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              fontStyle: 'bold',
              callback: label => label.split('\n')
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 0,
              stepSize: 0,
            }
          }
          ]
        }
      }
    }
  },
  computed: {
    generateAt() {
      return dayjs(this.resultOfVotes.data?.generated_at).format('DD MMMM YYYY HH:mm WIB')
    },
    totalVote() {
      const total = this.resultOfVotes.data?.statistics?.statistics?.statistics?.total_voters || 0
      return total?.toLocaleString('id-ID');
    },
  },
  mounted() {
    this.getRecapFaculty();
    this.getRecapCandidate();
    this.getRecapStatistics();
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
      await this.$router.replace('/login')
    },
    toggleAccordion(index) {
      // Inisialisasi jika key belum ada
      if (!(index in this.openAccordions)) {
        this.$set(this.openAccordions, index, false)
      }

      // Kalau sedang terbuka, maka tutup
      if (this.openAccordions[index]) {
        this.openAccordions[index] = false
      } else {
        // Kalau eksklusif, tutup semua dulu
        for (const key in this.openAccordions) {
          this.openAccordions[key] = false
        }
        // lalu buka yang diklik
        this.openAccordions[index] = true
      }
    },
    async getRecapFaculty() {
      try {
        this.resultOfVotes.fetching = 'pending'
        const { data } = await api.recap.getRecapFaculty()
        this.resultOfVotes.data = {
          ...this.resultOfVotes.data,
          faculties: data
        }
        this.resultOfVotes.fetching = 'resolved'
      } catch (error) {
        this.resultOfVotes.fetching = 'rejected'
        this.resultOfVotes.data = { message: error.message || 'Failed to fetch recapulation data' }
      }
    },
    async getRecapCandidate() {
      try {
        this.resultOfVotes.fetching = 'pending'
        const { data } = await api.recap.getRecapCandidate()
        this.resultOfVotes.data = {
          ...this.resultOfVotes.data,
          candidates: data
        }
        this.chartData.labels = data.candidates.candidates.sort((a, b) => a.no_urut - b.no_urut)
          .map(candidate => `${candidate.no_urut}\n${candidate.nama}`)
        this.chartData.datasets[0].data = data.candidates.candidates.sort((a, b) => a.no_urut - b.no_urut)
          .map(candidate => candidate.vote_count)
        const max = data.candidates.candidates.sort((a, b) => a.vote_count - b.vote_count)
          .map(candidate => candidate.vote_count)?.[0] + 20000
        const stepSize = Math.ceil(max / 10)

        this.chartOptions.scales.yAxes[0].ticks.max = max
        this.chartOptions.scales.yAxes[0].ticks.stepSize = stepSize

        this.resultOfVotes.fetching = 'resolved'
      } catch (error) {
        this.resultOfVotes.fetching = 'rejected'
        this.resultOfVotes.data = { message: error.message || 'Failed to fetch recapulation data' }
      }
    },
    async getRecapStatistics() {
      try {
        this.resultOfVotes.fetching = 'pending'
        const { data } = await api.recap.getRecapStatistics()
        this.resultOfVotes.data = {
          ...this.resultOfVotes.data,
          statistics: data
        }

        this.resultOfVotes.fetching = 'resolved'
      } catch (error) {
        this.resultOfVotes.fetching = 'rejected'
        this.resultOfVotes.data = { message: error.message || 'Failed to fetch recapulation data' }
      }
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Roboto', sans-serif;
}

.card-text {
  font-size: 18px;
  color: #000;
}

.btn,
.btn-secondary {
  background-color: #FEDC00 !important;
  border: 0px;
}

.btn:hover,
.btn-secondary:hover {
  box-shadow: none !important;
}

.icon-right {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.icon-right.open {
  transform: translateY(-50%) rotate(90deg);
}

@media (max-width: 640px) {
  .mobile-size {
    width: 100vw !important;
  }

  .wrapper-button-pemenang {
    width: 100vw !important;
  }
}

#wrapper-mobile-size {
  display: flex;
  justify-content: center;
  width: 100vw;
  min-height: 100vh;
  background-color: #E5E5E5;
  padding: 0px 16px 16px 16px;
}

.wrap {
  width: 100%;
  max-width: 1400px;
  min-height: 100vh;
  background-color: #e5e5e5;
}

#wrapper-content {
  width: 100%;
}

.btn-logout {
  position: fixed;
  bottom: 10px;
  right: 20px;
  padding: 10px 20px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.wrap-header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  background: #fff;
  padding: 10px;
}

.wrap-header img {
  width: auto;
  height: 80px;
}

.wrap-header img:nth-child(2) {
  height: 40px;
}

.wrap-header img:nth-child(3) {
  height: 40px;
}

.title {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
}

.title h1 {
  font-size: 24px;
  color: #000;
  font-weight: 700;
  margin: 0px
}

.title span {
  font-size: 20px;
  color: #000;
  font-weight: 700;
  margin: 0px
}

.wrap-count-vote {
  background: #fff;
  min-height: 200px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px #00000040;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 20px;
}

.wrap-count-vote h2 {
  font-size: 25px;
  color: #1B1B1B;
  font-weight: 700;
}

.wrap-count-vote h3 {
  font-size: 69px;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
  display: inline-block;
  position: relative;
  color: #45acd8;
}

.wrap-count-vote-chart {
  background: #fff;
  min-height: 200px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 20px 24px;
  margin-bottom: 20px;
}

.wrap-count-vote-chart h2 {
  font-size: 22px;
  color: #1B1B1B;
  font-weight: 700;
}

.wrap-card-content {
  display: flex;
  border-bottom: 1px solid #000;
  width: 100%;
  color: #000;
  font-weight: 800;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
}

.wrap-card-content>span {
  width: 60px;
}

.wrap-card-content>div {
  width: 100%;
  padding-right: 58px;
}
</style>
